/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_AddInputs */

const fr_rooms_add = /** @type {(inputs: Rooms_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une chambre`)
};

const en_rooms_add = /** @type {(inputs: Rooms_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a room`)
};

/**
* | output |
* | --- |
* | "Add a room" |
*
* @param {Rooms_AddInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_add = /** @type {((inputs?: Rooms_AddInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_AddInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_add(inputs)
	return en_rooms_add(inputs)
});